import cyjDetail from './cyj-detail.vue'

export default cyjDetail
